import React, { memo } from 'react';
import { Navigate } from 'react-router';
import { Spin } from 'antd';
import { useFeatureStore } from '../../zustand/features';
import Forbidden from '../Error/Forbidden';

export interface FeatureRouteProps {
  feature: string | string[];
  allRequired?: boolean;
  children?: React.ReactNode;
  element?: React.ReactElement;
  redirectTo?: string;
}

export const FeatureRoute: React.FC<FeatureRouteProps> = memo(
  ({ feature, allRequired = true, children, element, redirectTo }) => {
    const isLoaded = useFeatureStore((state) => state?.isLoaded ?? false);
    const hasAccess = useFeatureStore((state) => {
      if (!feature) return true;
      const features = state?.features ?? [];
      if (Array.isArray(feature)) {
        if (feature.length === 0) return true;
        return allRequired
          ? feature.every((f) => features.includes(f))
          : feature.some((f) => features.includes(f));
      }
      return features.includes(feature);
    });

    if (!isLoaded) {
      return (
        <div className='flex h-[60vh] w-full items-center justify-center'>
          <Spin size='large' />
        </div>
      );
    }

    if (!hasAccess) {
      if (redirectTo) {
        return <Navigate to={redirectTo} replace />;
      }
      return <Forbidden />;
    }

    return <>{element || children}</>;
  }
);

FeatureRoute.displayName = 'FeatureRoute';

export default FeatureRoute;
